module.exports = __webpack_public_path__ + "static/exercise-img-5-d17bd1720fbffe79cc37d6a06b6d9951.png";